/*
* 组织架构组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Button,
    InputNumber,
    Space,
    Tag,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    isGTscreenWidth,
    ShowIPModal,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';

import Entity from './OrgStructureEntity.js';

const Option = Select.Option;
const MODULENAME = CNF.navItems[0].submenu[1].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[1].ptn;

class Lists extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ulid: '',
            record: null,
            dataLists: this.props.dataLists,
        }
    }

    update = (record) => { this.props.setOpen(true, record); }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    operation = (action, record) => {
        let uri = 'org/structures/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                this.update(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.username, action, MODULENAME, this.props.isRefresh, uri);
                break
            default:
                break;
        }
    }

    render() {
        const columns = [
            { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
            {
                title: '架构层级', key: 'level',
                sorter: (a, b) => a.level - b.level,
                render: (record) => <Tag color={CNF.swatches[CNF.currentSwatche][0]}>{record.level}</Tag>
            },
            {
                title: '层级序号', key: 'sn',
                sorter: (a, b) => a.sn - b.sn,
                render: (record) => <Tag color={CNF.swatches[CNF.currentSwatche][1]}>{record.sn}</Tag>
            },
            { title: '架构标题', dataIndex: 'title', key: 'title', },
            {
                title: '负责人员', key: 'name',
                render: (record) => record.name ? record.name : '-'
            },
            {
                title: '组织职能类型', key: 'org_function_type',
                render: (record) => CNF.orgFunctionTypes.find(item => parseInt(record.org_function_type) === parseInt(item.value))?.key,
            },
            { title: '状态', dataIndex: 'status', key: 'status', width: CNF.tableStatusColumnWidth, },
            { title: '创建人员', dataIndex: 'create_displayname', key: 'create_displayname', fixed: 'right', width: CNF.tableCreateDisplayeColumnWidth, },
            { title: '创建时间', dataIndex: 'create_time', key: 'create_time', fixed: 'right', width: CNF.tableCreateTimeColumnWidth, },
            {
                title: '', key: 'operation', width: CNF.tableOperationColumnWidth, fixed: 'right',
                render: (record) => GetDropdownActionName(this.props.btnLists, MODULENAME_PTN, record, this.operation)
            }
        ];
        return (
            <div>
                <Table
                    columns={columns}
                    className='content-table-row'
                    size='middle'
                    dataSource={this.state.dataLists}
                    scroll={{ x: this.props.x }}
                    showSorterTooltip={{ target: 'sorter-icon' }}
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: CNF.pageSize,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current, pageSize) => this.props.changePageSize(pageSize, current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
            </div>
        );
    }
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            open: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            orgInfosLists: [],
            orgInfoULID: '',
            level: 0,
            title: '',
            orgFunctionType: '',
            status: CNF.status[0].value,
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeOrgInfoULID = (value) => { this.setState({ orgInfoULID: value }); }
    changeLevel = (value) => { this.setState({ level: value ? value : '' }); }
    changeTitle = (e) => { this.setState({ title: e.target.value }); }
    changeStatus = (value) => { this.setState({ status: value }); this.search(); }
    changeOrgFunctionType = (value) => { this.setState({ orgFunctionType: value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    setOpen = (value, record) => { this.setState({ open: value, record: record }); }
    create = () => { this.setOpen(true, null); }

    /**
     * 获取组织信息下拉列表
     */
    getOrgInfoLists = () => {
        const _this = this;
        const params = {
            'rss': 'list',
            'status': CNF.status[0].value,
        };
        $.ajax({
            url: `${CNF.api}org/infos${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
            dataType: 'JSON', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({ orgInfosLists: data.dat, orgInfoULID: data.dat[0].key });
                        _this.isRefresh();
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'org_info_ulid': this.state.orgInfoULID,
            'level': this.state.level,
            'title': this.state.title,
            'org_function_type': this.state.orgFunctionType,
            'status': this.state.status === undefined ? '' : this.state.status,
            'page_size': isGTscreenWidth ? CNF.pageSize : CNF.pageSize - 2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}org/structures${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getOrgInfoLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    {
                        this.state.orgInfosLists.length > 1 ? <Col span={isGTscreenWidth ? 4 : 5}>
                            <Select
                                placeholder='请选择组织'
                                style={{ width: '100%' }}
                                onChange={this.changeOrgInfoULID}
                                disabled={this.state.loading}
                            >
                                {
                                    this.state.orgInfosLists.map((item) => {
                                        return <Option key={item['key']} value={item['key']}>{item['name']}</Option>
                                    })
                                }
                            </Select>
                        </Col> : ''
                    }
                    <Col span={2} style={{ marginLeft: this.state.orgInfosLists && this.state.orgInfosLists.length > 1 ? CNF.searchMarginLeft : 0 }}>
                        <InputNumber
                            onChange={this.changeLevel}
                            placeholder='架构层级'
                            // value={this.state.level}
                            min={0}
                            max={9}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeTitle}
                            placeholder='架构标题'
                            value={this.state.title}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            placeholder='组织职能类型'
                            style={{ width: '100%' }}
                            onChange={this.changeOrgFunctionType}
                        >
                            {
                                CNF.orgFunctionTypes && CNF.orgFunctionTypes.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='状态'
                            value={this.state.status}
                            style={{ width: '100%' }}
                            onChange={this.changeStatus}
                        >
                            {
                                CNF.status && CNF.status.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                                <Button
                                    title={CNF.actionName.CREATE + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        this.create();
                                    }}>
                                    {CNF.actionName.CREATE}
                                </Button>
                            ) : ''
                        }
                    </Space>
                    <Entity
                        btnLists={this.props.btnLists}
                        preGroup={this.props.preGroup}
                        record={this.state.record}
                        open={this.state.open}
                        setOpen={this.setOpen}
                        isRefresh={this.isRefresh}
                        orgInfosLists={this.state.orgInfosLists}
                    />
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            setOpen={this.setOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT